import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@custom-components';
import { ActionLink } from '../../css/styledComponents.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

function TextButton({ children, onClick, disabled, noPadding }) {
  return (
    <ActionLink type="button" onClick={onClick} disabled={disabled} noPadding={noPadding}>
      <Text.HeadingSixth noMargins>{children}</Text.HeadingSixth>
    </ActionLink>
  );
}
TextButton.propTypes = {
  children: ReactChildrenPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  noPadding: PropTypes.bool
};
TextButton.defaultProps = {
  disabled: false,
  noPadding: false
};

export default TextButton;
